import { useStyletron } from 'baseui';
import { Block } from 'baseui/block';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';
import logo from '../assets/images/logo.jpg';


// ReDoFooter replicates the footer of blog.redo-please.com for the public landing
// page: three link columns (all external), social icons, and the copyright line.
// The blog's newsletter signup is intentionally omitted (it posts to the blog's own
// service); the "About" column already links out to the landing site and blog.
const COLUMNS = [
  {
    heading: 'Legal',
    links: [
      { label: 'Terms and Conditions', href: 'https://landing.redo-please.com/agb' },
      { label: 'Privacy Policy', href: 'https://landing.redo-please.com/privacy' },
      { label: 'Cookies', href: 'https://landing.redo-please.com/cookies' },
      { label: 'Imprint', href: 'https://landing.redo-please.com/imprint' },
    ],
  },
  {
    heading: 'About',
    links: [
      { label: 'Our Mission', href: 'https://landing.redo-please.com/mission' },
      { label: 'Nettiquette', href: 'https://landing.redo-please.com/nettiquette' },
      { label: 'Sustainability', href: 'https://landing.redo-please.com/sustainability' },
      { label: 'Jobs', href: 'https://landing.redo-please.com/jobs' },
      { label: 'Landing', href: 'https://landing.redo-please.com/' },
      { label: 'Blog', href: 'https://blog.redo-please.com/' },
    ],
  },
  {
    heading: 'Get in touch',
    links: [
      { label: 'Contact', href: 'https://landing.redo-please.com/contact' },
      { label: 'Help Center', href: 'https://landing.redo-please.com/help' },
      { label: 'Feedback', href: 'https://landing.redo-please.com/feedback' },
    ],
  },
];

const ReDoFooter = () => {
  const [css, theme] = useStyletron();

  const linkClass = css({
    color: theme.colors.white,
    opacity: '0.85',
    textDecoration: 'none',
    fontSize: '14px',
    lineHeight: '2',
    ':hover': { opacity: '1', textDecoration: 'underline' },
  });

  const headingClass = css({
    color: theme.colors.white,
    fontSize: '13px',
    fontWeight: '700',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    marginBottom: '8px',
  });

  return (
    <Block
      as='footer'
      width='100%'
      backgroundColor={theme.colors.primary400}
      color={theme.colors.white}
      padding={['4ch 2ch', '4ch 2ch', '5ch 4ch', '5ch 6ch']}
      overrides={{ Block: { style: { boxSizing: 'border-box' } } }}
    >
      <Block
        maxWidth='1100px'
        margin='0 auto'
        display='flex'
        flexWrap='wrap'
        gridGap='4ch'
        justifyContent='space-between'
      >
        {/* Brand + social */}
        <Block display='flex' flexDirection='column' gridGap='1.5ch' minWidth='180px'>
          <Block display='flex' alignItems='center' gridGap='1ch'>
            <img src={logo} alt='ReDo' width='40' height='40' className={css({ borderRadius: '8px' })} />
            <span className={css({ fontWeight: '700', fontSize: '18px', color: theme.colors.white })}>ReDo</span>
          </Block>
          <Block display='flex' gridGap='1.5ch' marginTop='0.5ch'>
            <a aria-label='Instagram' className={css({ color: theme.colors.white, display: 'flex' })} href='https://www.instagram.com/redo_please/' target='_blank' rel='noreferrer'>
              <FaInstagram size={24} />
            </a>
            <a aria-label='LinkedIn' className={css({ color: theme.colors.white, display: 'flex' })} href='https://www.linkedin.com/company/redo-please' target='_blank' rel='noreferrer'>
              <FaLinkedin size={24} />
            </a>
          </Block>
        </Block>

        {/* Link columns */}
        {COLUMNS.map((column) => (
          <Block key={column.heading} display='flex' flexDirection='column' minWidth='150px'>
            <div className={headingClass}>{column.heading}</div>
            {column.links.map((link) => (
              <a key={link.label} className={linkClass} href={link.href} target='_blank' rel='noreferrer'>
                {link.label}
              </a>
            ))}
          </Block>
        ))}
      </Block>

      <Block
        maxWidth='1100px'
        margin='3ch auto 0 auto'
        paddingTop='2ch'
        overrides={{ Block: { style: { borderTop: `1px solid ${theme.colors.white}33` } } }}
      >
        <span className={css({ fontSize: '13px', opacity: '0.8', color: theme.colors.white })}>
          © 2026 ReDo UG (haftungsbeschränkt)
        </span>
      </Block>
    </Block>
  );
};

export default ReDoFooter;
